<template>

  <div class="dashboard">

    <NavigationBar id="dashboardNavigationBarId" ref="dashboardNavigationBarRef">
        <template v-slot:center>
          {{ betgameName }}
        </template>
    </NavigationBar>

    <!-- Ad: Bwin Bannner -->
    <BwinBanner></BwinBanner>

    <!-- Profile Card -->
    <ProfileCard></ProfileCard>

    <!-- Nächster Spieltag / Countdown -->
    <!-- Optional: Nur sichtbar, wenn kein aktiver Spieltag -->
    <MatchdaySlider></MatchdaySlider>

    <!-- Aktiver Spieltag -->
    <!--
      <small>Aktueller Spieltag</small>
      <DashboardLiveStatisticsOneMatch v-if="this.selectedDashboardLiveView === 1" :match="singleMatch"></DashboardLiveStatisticsOneMatch>
      <DashboardLiveStatisticsTwoMatches v-else-if="this.selectedDashboardLiveView === 2" :matches="twoMatches"></DashboardLiveStatisticsTwoMatches>
      <DashboardLiveStatisticsMultipleMatches v-else-if="this.selectedDashboardLiveView === 3" :runningMatchday="this.runningMatchday"></DashboardLiveStatisticsMultipleMatches>
    -->

    <DashboardRanking :rankings="dashboardRankings"></DashboardRanking>

    <BetgameDescription></BetgameDescription>

  </div>
</template>

<script>
import NavigationBar from './../components/NavigationBar'
import BwinBanner from './../components/BwinBanner'
import ProfileCard from './../components/ProfileCard'
import MatchdaySlider from './../components/MatchdaySlider'
import DashboardRanking from './../components/DashboardRanking'
import BetgameDescription from './../components/BetgameDescription'

export default {
  name: 'DashboardNew',
  components: { NavigationBar, BwinBanner, ProfileCard, MatchdaySlider, DashboardRanking, BetgameDescription },
  data () {
    return {}
  },
  beforeCreate () {
  },
  created () {
  },
  mounted () {
    if(!this.$store.getters.loggedIn || !this.isSPMUser()) {
      this.$router.push({ name: 'dashboard' }).catch(err => {})
    }
  },
  computed: {
    dashboardRankings() {
      if(!this.$store.state.userNeighbourRankings) {
        if (!this.$store.state.leagueId && this.getBGValue('spmbgid') && parseInt(this.getBGValue('spmbgid')) > 0) {
          this.$store.dispatch('fetchBetgameLeague', this.getBGValue('spmbgid'))
        }
      }
      return this.$store.getters.getRankingForDashboard
    },
    betgameName() {
      if(this.$store.state.betgame) {
        return this.$store.state.betgame.name
      } else {
        if(this.getBGValue('spmbgid') && parseInt(this.getBGValue('spmbgid')) > 0) {
          this.$store.dispatch('fetchBetgame', this.getBGValue('spmbgid'))
        }
      }
    },
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
  .dashboard-container {
    flex: 100%;
  }
  small {
    width: 100%;
    text-align: center;
    margin-bottom: -8px;

    @media screen and (min-width: 768px) {
      margin-bottom: -12px;
    }
  }
</style>
